import { render, staticRenderFns } from "./004welcomSheng.vue?vue&type=template&id=1dadc66c&scoped=true&"
import script from "./004welcomSheng.vue?vue&type=script&lang=js&"
export * from "./004welcomSheng.vue?vue&type=script&lang=js&"
import style0 from "./004welcomSheng.vue?vue&type=style&index=0&id=1dadc66c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dadc66c",
  null
  
)

export default component.exports